import { ArtistMinifiedType, useDeleteArtist as useDeleteArtistApi } from '@api';
import { useNotification } from '@common';
import { modals } from '@mantine/modals';
import { AxiosError } from 'axios';
import { useTranslation } from 'react-i18next';

const TRANS_PATH = 'TABLE.ACTIONS';
const TRANS_PATH_NOTIFICATION = 'NOTIFICATIONS.DELETE_ARTIST' as const;

type UseDeleteArtistReturnType = {
  handleDeleteArtist: (artist: ArtistMinifiedType) => void;
};

export const useDeleteArtist = (): UseDeleteArtistReturnType => {
  const { t } = useTranslation('artists');
  const { showSuccess, showError } = useNotification();
  const { mutate: mutateDelete } = useDeleteArtistApi();

  const onSuccess = (): void => {
    showSuccess({
      title: `${TRANS_PATH_NOTIFICATION}.SUCCESS.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.SUCCESS.MESSAGE`,
    });
  };

  const onError = (error: AxiosError): void => {
    showError({
      title: `${TRANS_PATH_NOTIFICATION}.ERROR.TITLE`,
      message: `${TRANS_PATH_NOTIFICATION}.ERROR.MESSAGE`,
      error,
    });
  };

  const onConfirm = (artist: ArtistMinifiedType): void => {
    mutateDelete({ artistId: artist.id }, { onSuccess, onError });
  };

  const handleDeleteArtist = (artist: ArtistMinifiedType): void => {
    modals.openConfirmModal({
      title: t(`${TRANS_PATH}.DELETE_CONFIRMATION_TITLE`),
      labels: {
        confirm: t(`${TRANS_PATH}.DELETE_CONFIRM_BUTTON`),
        cancel: t('CANCEL_BUTTON', { ns: 'common' }),
      },
      confirmProps: {
        color: 'red',
      },
      onConfirm: () => onConfirm(artist),
    });
  };

  return { handleDeleteArtist };
};
